// extracted by mini-css-extract-plugin
export default {"project-logo":"project-logo_project-logo__0XEJI"};